export const STEPS = {
  PERSONAL_INFO: "personal-info",
  LOCATION_INFO: "location-info",
  EDUCATION_HISTORY: "education-history",
  WORK_HISTORY: "work-history",
  SUBJECT_SELECTION: "subject-selection",
  VERIFICATION: "verification-info",
  SCHEDULE_INFO: "schedule-info",
  AGREEMENT_INFO: "agreement-info",
  GUARANTOR_INFO: "guarantors-info",
  PAYMENT_INFO: "payment-info",
  NEW_DEVELOPMENT: "new-development-info",
  TEACHING_PROFILE: "teaching-profile",
  VIDEO_SUMMARY: "video-summary",
  VERIFY_EMAIL: "verify-email",
  UPLOAD_EDUCATION: "upload-education",
  UPLOAD_WORK: "upload-work",
  POST_APPLICATION_1: "post-application-1",
  POST_APPLICATION_2: "post-application-2",
};

export function union(arrA: any[], arrB: any[]) {
  let setA = new Set(arrA);
  let setB = new Set(arrB);
  let _union = new Set(setA);
  for (let elem of setB) {
    _union.add(elem);
  }
  return [..._union];
}

export function intersection(arrA: any[], arrB: any[]) {
  let setA = new Set(arrA);
  let setB = new Set(arrB);
  let _intersection = new Set();
  for (let elem of setB) {
    if (setA.has(elem)) {
      _intersection.add(elem);
    }
  }
  return [..._intersection];
}
